import CmsApi from '../utilities/cms-api';
import Gallery from '../includes/gallery';
import Dependencies from "../utilities/dependencies";

export default class Room {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.room-element'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [Dependencies.libraries.glightbox];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	#propertyId;
	#roomId;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#propertyId = parseInt(this.#holderElement.dataset.propertyId);
		this.#roomId = parseInt(this.#holderElement.dataset.roomId);
		const galleryElement = document.querySelector('.gallery-wrapper');

		if (!document.querySelector('h1')) {
			let titleWrapper = this.#holderElement.querySelector('.title-wrapper');
			let div = document.createElement('div');
			let h1 = document.createElement('h1');
			h1.innerHTML = titleWrapper.querySelectorAll('h4')[0].innerHTML;
			titleWrapper.replaceChild(h1, titleWrapper.querySelectorAll('h4')[0]);
		}

		CmsApi.fetchRoom(this.#propertyId, this.#roomId)
			.then(room => {
				if (this.#holderElement.querySelector('.trigger-floor-plan-view')) {
					this.#holderElement.querySelector('.trigger-floor-plan-view').addEventListener('click', function() {
						Gallery.alpineData.slides = room.floorPlans;
						document.querySelector('html').style.overflow = 'hidden';
						galleryElement.style.height = '100vh';
						galleryElement.querySelector('button').style.position = 'fixed';
					});
				}

				this.#holderElement.querySelector('.trigger-gallery-view').addEventListener('click', function() {
					let gallery = [];
					room.slides.forEach(slide => {
						gallery.push({
							'href': slide.image.lg,
							'type': 'image',
							'alt': slide.image.alt,
						});
					});
					const lightbox = GLightbox({
						elements: gallery,
						autoplayVideos: false,
					});
					lightbox.open();
				});
			});
	}
}
